<template>
  <div id="app" class="mb-3">
    <Cursors v-show="!showLivePanel && $route.name === 'Home'" />

    <!-- ACTION TOOLBAR -->
    <transition name="fade">
      <div
        v-if="livestream && !showCookieNotice"
        class="
          fixed
          bottom-0
          right-0
          p-8
          md:p-12
          z-40
          mono
          flex flex-col
          md:flex-row
          md:space-x-6
          space-y-3
          md:space-y-0
          text-center
          md:flex
          justify-end
          w-full
          md:w-auto
        "
        :class="{
          hidden: hidingButtons,
          'pb-0 mb-16 md:p-6 md:pt-4 md:top-0 md:bottom-auto': showLivePanel,
        }"
      >
        <!-- <div
          v-if="live && !showLivePanel"
          @click="showLivePanel = true"
          class="bg-red-600 py-3 px-8 rounded-full cursor-pointer"
        >
          <span class="pulse">Live Now! Click to Watch</span>
        </div>
        <div v-else-if="!showLivePanel" class="bg-grey py-3 px-8 rounded-full">
          Livestream begins {{ distance }}
        </div> -->
        <div
          @click="$scrollTo('#calendar', 300, { offset: -80 })"
          class="bg-grey py-3 px-8 rounded-full cursor-pointer"
        >
          The Livestreams have concluded! View the Archive.
        </div>
        <a
          href="https://t.me/joinchat/7yhQP29uZy1jZThi"
          target="_blank"
          class="
            bg-telegram-blue
            text-white
            rounded-full
            px-3
            md:px-6
            py-3
            hover:text-white
            leading-snug
          "
          v-if="true || showLivePanel"
        >
          <!-- <span class="pulse">💬</span> JOIN THE Q&A CHAT VIA TELEGRAM! -->
          <span class="pulse">💬</span> JOIN THE COMMUNITY CHAT VIA TELEGRAM!
        </a>
      </div>
    </transition>

    <div
      v-if="showCookieNotice"
      id="cookie-notice"
      class="
        fixed
        bottom-0
        right-0
        m-8
        md:m-12
        border border-white
        p-6
        md:p-8
        mono
        z-20
        bg-black
        max-w-2xl
      "
      @mouseover="$store.commit('SET_SHOW_MY_CURSOR', false)"
    >
      <div>
        We would like to use cookies to know how many people visited the site
        and to stream video content from YouTube. We use Google Analytics with
        anonymized IP addresses. Data is only stored 35 days.
      </div>
      <div class="mt-3 flex flex-col md:flex-row justify-between">
        <div class="flex space-x-2 md:space-x-6 my-3 md:my-0">
          <span
            @click="acceptCookies"
            class="cursor-pointer hover:underline"
            title="Accept cookies - Anonymized IP over Google Analytics"
            >Accept</span
          >,
          <span
            @click="declineCookies"
            class="cursor-pointer hover:underline"
            title="Decline Cookies"
            >Decline</span
          >
        </div>
        <div class="mt-6 md:mt-0 text-xs md:text-base">
          <a
            href="https://www.gorki.de/en/datenschutz"
            target="_blank"
            title="GORKI/YCA Privacy Policy - External Link"
            >Privacy Policy</a
          >
        </div>
      </div>
    </div>
    <div
      id="nav"
      class="
        flex
        justify-between
        p-6
        relative
        z-10
        sticky
        top-0
        left-0
        right-0
        mono
      "
    >
      <router-link
        to="/"
        @click.native="$scrollTo('#app', 300)"
        title="Young Curators Academy - Home"
        ><span class="hidden md:inline">Young Curators Academy</span
        ><span class="md:hidden">YCA</span></router-link
      >
      <ul class="flex space-x-4">
        <li class="cursor-pointer">
          <router-link
            to="/#about"
            @click.native="$scrollTo('#about', 300, { offset: -80 })"
            title="About the YCA"
            >About</router-link
          >
        </li>
        <li class="cursor-pointer">
          <router-link
            to="/#calendar"
            @click.native="$scrollTo('#calendar', 300, { offset: -80 })"
            title="YCA Calendar"
            >Calendar</router-link
          >
        </li>
        <li class="cursor-pointer">
          <router-link
            to="/#people"
            @click.native="$scrollTo('#people', 300, { offset: -80 })"
            title="YCA People"
            >People</router-link
          >
        </li>
        <li class="cursor-pointer">
          <a
            href="https://gorki.de"
            title="Maxim Gorki Theater - External Link"
            target="_blank"
            >GORKI</a
          >
        </li>
        <!-- <li>Menu</li> -->
      </ul>
    </div>

    <router-view
      :content="content"
      :livestream="livestream"
      @showLiveStreamPanel="showLivePanel = true"
      @hideButtons="hideButtons"
      ref="route"
    />

    <div v-if="content" class="my-3 mx-6 space-x-4">
      <a href="https://gorki.de" target="_blank">Maxim Gorki Theater</a>
      <a href="https://www.gorki.de/en/datenschutz" target="_blank"
        >Privacy Policy</a
      >
      <a href="https://content.youngcuratorsacademy.com/imprint" target="_blank"
        >Imprint</a
      >
    </div>

    <div
      v-if="livestream && showLivePanel"
      id="livestream"
      class="
        fixed
        inset-0
        bg-black
        z-20
        flex
        items-center
        justify-center
        w-full
      "
      @mouseover="$store.commit('SET_SHOW_MY_CURSOR', false)"
    >
      <div
        class="fixed top-0 left-0 pt-6 px-8 cursor-pointer mono z-20"
        @click="closeLive"
        title="Close the Live Stream"
        :class="{
          'hover:text-full-red': !livestream.message,
          'text-underline': livestream.message,
        }"
      >
        <span class="text-shadow">Close</span>
      </div>

      <div
        v-if="livestream.message"
        class="
          fixed
          top-0
          left-0
          right-0
          text-center
          pt-16
          leading-snug
          md:pt-6
          px-8
          mono
          z-10
          bg-full-red
          py-5
          text-white
        "
      >
        {{ livestream.message }}
      </div>

      <vue-plyr v-if="showLivePlayer" :options="videoOptions" ref="plyr">
        <div
          data-plyr-provider="youtube"
          :data-plyr-embed-id="livestream.livestream_id"
        ></div>
      </vue-plyr>
      <div v-else>
        <div class="flex flex-col space-y-16 md:text-xl mono px-6">
          <div
            @click="showLivePlayer = true"
            class="
              border border-white
              py-4
              px-8
              rounded-full
              text-center
              hover:bg-white
              hover:text-black
              cursor-pointer
              duration-200
              transition-all
            "
          >
            Open the <span class="text-full-red">YouTube</span> livestream
          </div>
          <a
            @click="tagZoom"
            :href="livestream.zoom_link"
            target="_blank"
            class="
              border border-white
              py-4
              px-8
              rounded-full
              text-center
              hover:bg-white
              hover:text-black
              cursor-pointer
              duration-200
              transition-all
              group
            "
          >
            For
            <strong class="text-full-green group-hover:text-black"
              >closed captions</strong
            >,<br class="md:hidden" />
            Join Zoom
          </a>
        </div>

        <div class="text-center text-xs mt-4 px-12">
          Clicking these links means you consent to the Privacy Policy of
          <a href="https://www.gorki.de/en/datenschutz" target="_blank">YCA</a>
          and
          <a href="https://policies.google.com/privacy?hl=en" target="_blank"
            >Youtube</a
          >
          or
          <a href="https://zoom.us/privacy" target="_blank">Zoom</a>
        </div>
      </div>
    </div>

    <!-- <div class="fixed bottom-0 right-0 m-12">
      <div v-if="showChat">
        <div class="cursor-pointer text-right" @click="showChat = false">
          Close
        </div>
        <iframe
          v-if="showChat"
          src="https://minnit.chat/YoungCuratorsAcademy?embed&mobile&nickname="
          width="400"
          height="300"
          style="border: none"
          allowTransparency="true"
        ></iframe>
      </div>
      <div v-else class="cursor-pointer" @click="showChat = true">Chat</div>
    </div> -->
  </div>
</template>

<script>
import Cursors from '@/components/Cursors.vue'
import { isPast, formatDistanceToNow } from 'date-fns'
import { bootstrap } from 'vue-gtag'

export default {
  name: 'App',
  components: { Cursors },
  data() {
    return {
      content: null,
      livestream: null,
      showChat: false,
      videoOptions: {
        muted: false,
        autoplay: true,
        playsinline: true,
        loop: { active: true },
      },
      showLivePanel: false,
      showLivePlayer: false,
      showCookieNotice: false,
      hidingButtons: false,
    }
  },
  mounted() {
    if (this.$cookies.isKey('YCAAllowCookies')) {
      if (this.$cookies.get('YCAAllowCookies')) {
        bootstrap()
      }
    } else {
      this.showCookieNotice = true
    }

    if (process.env.VUE_APP_PRELOAD_ENABLED && window.PRELOADED) {
      this.content = window.PRELOADED.data
    } else {
      fetch(`${process.env.VUE_APP_API_ROOT}/init.json`, {
        mode: 'cors',
      }).then((res) => {
        res.json().then((json) => (this.content = json))
      })
    }

    this.fetchLivestream()
    window.setInterval(this.fetchLivestream, 5000)
  },
  computed: {
    live() {
      return this.livestream.livestream_active == 'true'
    },
    distance() {
      if (isPast(new Date(this.livestream.livestream_start))) {
        return 'Shortly'
      } else {
        return (
          'in ' +
          formatDistanceToNow(new Date(this.livestream.livestream_start))
        )
      }
    },
  },
  methods: {
    acceptCookies() {
      this.$cookies.set('YCAAllowCookies', true, '14d')
      bootstrap()
      this.showCookieNotice = false
      this.$refs.route.acceptCookies()
    },
    declineCookies() {
      this.$cookies.set('YCAAllowCookies', false)
      this.showCookieNotice = false
    },
    hideButtons(val) {
      this.hidingButtons = val
    },
    closeLive() {
      this.showLivePanel = false
      this.showLivePlayer = false
    },
    fetchLivestream() {
      fetch(`${process.env.VUE_APP_API_ROOT}/livestream.json`, {
        mode: 'cors',
      }).then((res) => {
        res.json().then((json) => {
          if (this.livestream !== json) {
            this.livestream = json
          }
        })
      })
    },
    tagZoom() {
      this.$gtag.event('open_zoom', {
        event_category: 'livestream',
        event_label: 'zoom',
      })
    },
  },
  beforeDestroy() {
    window.clearInterval(this.fetchLivestream)
  },
  watch: {
    showLivePlayer() {
      if (this.showLivePlayer) {
        this.$gtag.event('open_livestream_panel', {
          event_category: 'livestream',
          event_label: 'livestream_panel',
        })

        this.$nextTick(() => {
          this.$refs.plyr.player.on('play', () => {
            this.$gtag.event('play_youtube_video', {
              event_category: 'livestream',
              event_label: 'play',
            })
          })
          this.$refs.plyr.player.on('playing', () => {
            this.$gtag.event('playing_youtube_video', {
              event_category: 'livestream',
              event_label: 'playing',
            })
          })
          this.$refs.plyr.player.on('pause', () => {
            this.$gtag.event('pause_youtube_video', {
              event_category: 'livestream',
              event_label: 'pause',
            })
          })
        })
      } else {
        this.$gtag.event('close_livestream', {
          event_category: 'livestream',
          event_label: 'close',
        })
      }
    },
  },
}
</script>

<style lang="css">
@import './css/app.css';

.plyr {
  width: 100%;
}

.plyr__video-wrapper.plyr__video-embed,
.plyr__video-embed.plyr__video-wrapper-fixed-ratio {
  padding-bottom: 56.25% !important;
}

#livestream {
  >>> .plyr__video-wrapper.plyr__video-embed,
  .plyr__video-embed.plyr__video-wrapper-fixed-ratio {
    padding-bottom: 56.25% !important;
  }
}
.text-shadow {
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.7);
}
</style>
